


























import { Component, Mixins } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import Button from '@/components/Button.vue';
import SurveyPageFooter from '@/components/SurveyPageFooter.vue';
import IconClose from '@/components/IconClose.vue';
import GoogleMapsMixin from '@/mixins/googleMapsMixin';

@Component({
  name: 'ai-error-prompt',
  components: {
    Header,
    Button,
    SurveyPageFooter,
    IconClose,
  },
})
export default class AiErrorPrompt extends Mixins(GoogleMapsMixin) {}
